import PropTypes from 'prop-types'
import React from 'react'
//import { GoogleMap, withGoogleMap, withScriptjs } from 'react-google-maps'
import { GoogleMap, withGoogleMap } from 'react-google-maps'

export function Map({ zoom, ...others }: props) {
  return (
    <GoogleMap {...others} defaultZoom={zoom} />
  )
}

Map.propTypes = {
  zoom: PropTypes.number,
}

Map.defaultProps = {
  zoom: 12,
}

//export default withScriptjs(withGoogleMap(Map))
export default withGoogleMap(Map)



// WEBPACK FOOTER //
// ./src/components/Map/Map.js